
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import logo from "../../assets/Images/logo.png";
import { FaBars } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import { IoSearchSharp } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
import { MdOutlineMail } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";

let NavBar = () => {
    let [status, setStatus] = useState(false)
    let [bar, setBar] = useState(false)
    return (
        <header>
            {/* // <!-- ====== Navbar section ======= --> */}
            {/* // <!-- ===== logo ===== --> */}

            <nav className="navbar navbar-expand-lg">
                <div className="container pt-3">

                    {/* <!-- site logo --> */}

                    <Link to = "/" class="navbar-brand p-0"><img src={logo} alt="logo" /></Link>
                    <button className="navbar-toggler" onClick={() => setStatus(true)} type="button">
                        <FaBars color="#ffffff" />
                    </button>
                    <div class="collapse navbar-collapse justify-content-start align-items-center" id="navbarNav">
                        {/* <!-- menu --> */}
                        <ul className="navbar-nav d-flex gap-5 align-items-center me-auto">
                            <li className="nav-item"><NavLink to = "/" className="nav-link p-0" activeClassName = "active">Home</NavLink></li>
                            <li className="nav-item"><NavLink to = "/About" className="nav-link p-0" activeClassName = "active">About</NavLink></li>
                            <li className="nav-item"><NavLink to = "/Contact" className="nav-link p-0" activeClassName = "active">Contact</NavLink></li>
                            <li className="nav-item dropdown">
                                <a class="nav-link mx-2 dropdown-toggle p-0" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Pages
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                    <li><Link to = "/service" className="dropdown-item">Services</Link></li>
                                    {/* <li><Link to = "/pricing" className="dropdown-item">Pricing Plan</Link></li> */}
                                    <li><Link to = "/Project" className="dropdown-item">Portfolio</Link></li>
                                    <li><Link to = "/team" className="dropdown-item">Team</Link></li>
                                    <li><Link to = "/testimonial" className="dropdown-item">Testimonial</Link></li>
                                    <li><Link to = "/faq" className="dropdown-item">FAQ</Link></li>
                                    {/* <li><Link to = "/blog" className="dropdown-item">Blog</Link></li> */}
                                    <li><Link to = "/coming_soon" className="dropdown-item">Coming soon</Link></li>
                                    <li><Link to = "/404" className="dropdown-item">404</Link></li>
                                </ul>
                            </li>
                        </ul>
                        <div className="nav-right d-flex gap-5">
                            <p className="para1 m-0">Call Us: <span>+92 3069126229</span></p>
                            {/* <IoSearchSharp className="icon" /> */}
                            <FaBars className="icon" onClick={() => setBar(true)} />
                        </div>
                    </div>
                </div>
            </nav>

            {/* <!-- Sidebar --> */}
            {
                status ? (<aside id="mySidepanel" className="sidepanel">
                    <div class="sidebar">
                        <Link to = "/" class="p-0"><img src={logo} alt="logo" /></Link>
                        <button className="closebtn" onClick={() => setStatus(false)}>
                            <IoClose color="#ffffff" />
                        </button>
                    </div>
                    <div>
                        {/* <!-- side menus --> */}
                        <ul>
                            <li class="nav-item"><NavLink to = "/" className="nav-link" activeClassName = "active">Home</NavLink></li>
                            <li class="nav-item"><NavLink to = "/About" className="nav-link" activeClassName = "active">About</NavLink></li>
                            <li class="nav-item"><NavLink to = "/Contact" className="nav-link" activeClassName = "active">Contact</NavLink></li>
                            <li className="pages"><a href="#" className="text-decoration-none" activeClassName = "active">More</a></li>
                            <li className="collapse_btn nav-item d-flex justify-content-between flex-row-reverse">
                                <a className="nav-link plus_collapse" data-bs-toggle="collapse" href="#pages" role="button" aria-expanded="false" aria-controls="pages">
                                    <FaPlus color="#ffffff" />
                                </a>
                                <div className="collapse" id="pages">
                                    <ul>
                                        <li className="nav-item"><Link to = "/service" class="nav-link">Services</Link></li>
                                        {/* <li className="nav-item"><Link to = "/pricing" class="nav-link">Pricing Plan</Link></li> */}
                                        <li className="nav-item"><Link to = "/Project" class="nav-link">Portfolio</Link></li>
                                        <li className="nav-item"><Link to = "/team" class="nav-link">Team</Link></li>
                                        <li className="nav-item"><Link to = "/testimonial" class="nav-link">testimonial</Link></li>
                                        <li className="nav-item"><Link to = "/faq" class="nav-link">FAQ</Link></li>
                                        {/* <li className="nav-item"><Link to = "/blog" class="nav-link">Blog</Link></li> */}
                                        <li className="nav-item"><Link to = "/coming_soon" class="nav-link">Coming Soon</Link></li>
                                        <li clasnName="nav-item"><Link to = "/404" class="nav-link">404</Link></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </aside>) : null
            }

            {
                bar ? (
                    <section className="right-sidebar">
                        <div className="d-flex align-items-center justify-content-between">
                            <Link to = "/"><img src={logo} alt="logo" /></Link>
                            <button onClick={() => setBar(false)}><IoClose color="#ffffff" /></button>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        <Link to = "/About" className="btn_1">
                            Discover More
                        </Link>
                        <hr />
                        <h4 className="mt-4 mb-4">Connected Details:</h4>
                        <ul className="d-flex flex-column gap-3">
                            <li>
                                <a href="#"><FaPhone className="icon2" /></a>
                                <a href="#">abdullahkhalid7892@gmail.com</a>
                            </li>
                            <li>
                                <a href="#"><MdOutlineMail className="icon2" /></a>
                                <a href="#">+92 3069126229</a>
                            </li>
                            <li>
                                <a href="#"><IoMdTime className="icon2" /></a>
                                <a href="#">Office Hours: 8AM - 11PM Sunday - Weekend Day</a>
                            </li>
                        </ul>
                        <span className="d-flex gap-4 mt-4">
                            <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebook className="icon2" /></a>
                            <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram className="icon2" /></a>
                            <a href="#" target="blank"><FaXTwitter className="icon2" /></a>
                            <a href="https://www.linkedin.com/company/nexelis-technologies/" target="blank"><FaLinkedin className="icon2" /></a>
                        </span>
                    </section>) : null
            }


        </header>
    )
};

export default NavBar;